export const ERROR = {
  FORM_VALIDATION: 'FORM_VALIDATION',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  POST_NOT_FOUND: 'POST_NOT_FOUND',
  DAY_NOT_FOUND: 'DAY_NOT_FOUND',
  DAY_EXIST: 'DAY_EXIST',
  NOTIFICATION_NOT_FOUND: 'NOTIFICATION_NOT_FOUND',
  PROMPT_NOT_FOUND: 'PROMPT_NOT_FOUND',
  EMAIL_INVALID: 'EMAIL_INVALID',
  RESET_PASSWORD_INVALID: 'RESET_PASSWORD_INVALID',
  CONFLICT_DATA: 'CONFLICT_DATA',
  EVENT_NOT_FOUND: 'EVENT_NOT_FOUND',
  EVENT_RELOAD_DATA: 'EVENT_RELOAD_DATA',
  BANNER_NOT_FOUND: 'BANNER_NOT_FOUND',
  BANNER_RELOAD_DATA: 'BANNER_RELOAD_DATA',
  CHAT_FUKUMARU_NOT_FOUND: 'CHAT_FUKUMARU_NOT_FOUND',
  CHAT_FUKUMARU_RELOAD_DATA: 'CHAT_FUKUMARU_RELOAD_DATA',
  COMMENT_NOT_FOUND: 'COMMENT_NOT_FOUND',
  INCORRECT_LOGIN: 'INCORRECT_LOGIN',
  ZIP_CODE_NOT_FOUND: 'ZIP_CODE_NOT_FOUND',
  PROMPT_ENABLE_EXIST: 'PROMPT_ENABLE_EXIST',
  SURVEY_NOT_FOUND: 'SURVEY_NOT_FOUND',
  CONTENT_NOT_FOUND: 'CONTENT_NOT_FOUND',
  CONTENT_RELOAD_DATA: 'CONTENT_RELOAD_DATA',
  SURVEY_RELOAD_DATA: 'SURVEY_RELOAD_DATA',
  CANT_EDIT_SURVEY_HAVE_PEOPLE_JOIN: 'CANT_EDIT_SURVEY_HAVE_PEOPLE_JOIN',
  NOTIFICATION_REMIND_NOT_FOUND: 'NOTIFICATION_REMIND_NOT_FOUND',
  NOTIFICATION_REMIND_RELOAD_DATA: 'NOTIFICATION_REMIND_RELOAD_DATA',
  CANT_ACTION_NOTIFICATION_REMIND_PUBLISHED:
    'CANT_ACTION_NOTIFICATION_REMIND_PUBLISHED',
  SURVEY_HEALTH_NOT_FOUND: 'SURVEY_HEALTH_NOT_FOUND',
  SURVEY_HEALTH_RELOAD_DATA: 'SURVEY_HEALTH_RELOAD_DATA',
  SURVEY_HEALTH_QUESTION_NOT_FOUND: 'SURVEY_HEALTH_QUESTION_NOT_FOUND',
  SURVEY_HEALTH_QUESTION_RELOAD_DATA: 'SURVEY_HEALTH_QUESTION_RELOAD_DATA',
  VERSION_NOT_FOUND: 'VERSION_NOT_FOUND',
  VERSION_EXIST: 'VERSION_EXIST',
  CALENDAR_POST_NOT_FOUND: 'CALENDAR_POST_NOT_FOUND',
  CALENDAR_POST_RELOAD_DATA: 'CALENDAR_POST_RELOAD_DATA',
  PARTNER_NOT_FOUND: 'PARTNER_NOT_FOUND',
  PARTNER_RELOAD_DATA: 'PARTNER_RELOAD_DATA',
  OFFER_NOT_FOUND: 'OFFER_NOT_FOUND',
  OFFER_RELOAD_DATA: 'OFFER_RELOAD_DATA',
  CATEGORY_NOT_FOUND: 'CATEGORY_NOT_FOUND',
  CATEGORY_RELOAD_DATA: 'CATEGORY_RELOAD_DATA',
  CATEGORY_IN_USE: 'CATEGORY_IN_USE',
  ARTICLE_NOT_FOUND: 'ARTICLE_NOT_FOUND',
  ARTICLE_RELOAD_DATA: 'ARTICLE_RELOAD_DATA',
  DELETE_UNSUCCESS: 'DELETE_UNSUCCESS',
  OFFER_IN_USE: 'OFFER_IN_USE',
  ARTICLE_IN_USE: 'ARTICLE_IN_USE',
  QUIZ_RELOAD_DATA: 'QUIZ_RELOAD_DATA',
  COMPANY_NOT_FOUND: 'COMPANY_NOT_FOUND',
  ARTICLE_ASSIGNED_TO_OTHER_COMPANY: 'ARTICLE_ASSIGNED_TO_OTHER_COMPANY',
};

export const ERROR_MESSAGE = {
  DAY_EXIST: 'Day already exists.',
  NOTIFICATION_NOT_FOUND: 'お知らせが見つかりませんでした。',
  EMAIL_INVALID: 'Email is not found.',
  CONFLICT_DATA:
    'データに変更がありました。このページを再読み込みしてください。',
  USER_NOT_FOUND: 'ユーザーが見つかりませんでした。',
  DAY_NOT_FOUND: 'SPECIAL_DAY_NOT_FOUND',
  POST_NOT_FOUND: 'POST_NOT_FOUND',
  EVENT_NOT_FOUND: 'イベントが見つかりませんでした。',
  EVENT_RELOAD_DATA:
    'データに変更がありました。このページを再読み込みしてください。',
  BANNER_NOT_FOUND: 'バナーが見つかりませんでした。',
  BANNER_RELOAD_DATA:
    'データに変更がありました。このページを再読み込みしてください。',
  CHAT_FUKUMARU_NOT_FOUND: 'トーク - フクマルが見つかりませんでした。',
  CHAT_FUKUMARU_RELOAD_DATA:
    'データに変更がありました。このページを再読み込みしてください。',
  COMMENT_NOT_FOUND: 'COMMENT_NOT_FOUND',
  INCORRECT_LOGIN: 'Incorrect email or password',
  ZIP_CODE_NOT_FOUND: 'この番号では検索できません。',
  PROMPT_ENABLE_EXIST: '有効のプロンプトはすでに存在してます',
  SURVEY_NOT_FOUND: 'アンケートが見つかりませんでした。',
  CONTENT_NOT_FOUND: 'コンテンツが見つかりませんでした。',
  CONTENT_RELOAD_DATA:
    'データに変更がありました。このページを再読み込みしてください。',
  SURVEY_RELOAD_DATA:
    'データに変更がありました。このページを再読み込みしてください。',
  CANT_EDIT_SURVEY_HAVE_PEOPLE_JOIN:
    'このアンケートに参加したユーザーがいますので、更新できませんでした。',
  NOTIFICATION_REMIND_NOT_FOUND: 'お知らせが見つかりませんでした。',
  NOTIFICATION_REMIND_RELOAD_DATA:
    'データに変更がありました。このページを再読み込みしてください。',
  CANT_ACTION_NOTIFICATION_REMIND_PUBLISHED:
    'データに変更がありました。このページを再読み込みしてください。',
  SURVEY_HEALTH_NOT_FOUND: 'アンケートが見つかりませんでした。',
  SURVEY_HEALTH_RELOAD_DATA:
    'データに変更がありました。このページを再読み込みしてください。',
  SURVEY_HEALTH_QUESTION_NOT_FOUND: '質問が見つかりませんでした。',
  SURVEY_HEALTH_QUESTION_RELOAD_DATA:
    'データに変更がありました。このページを再読み込みしてください。',
  VERSION_NOT_FOUND: 'このアプリバージョンが見つかりませんでした。',
  VERSION_EXIST: 'このアプリバージョンが存在しています。',
  CALENDAR_POST_NOT_FOUND: 'カレンダー投稿が見つかりませんでした。',
  CALENDAR_POST_RELOAD_DATA:
    'データに変更がありました。このページを再読み込みしてください。',
  PARTNER_NOT_FOUND: 'パートナーが見つかりませんでした。',
  PARTNER_RELOAD_DATA:
    'データに変更がありました。このページを再読み込みしてください。',
  OFFER_NOT_FOUND: 'オファーが見つかりませんでした。',
  OFFER_RELOAD_DATA:
    'データに変更がありました。このページを再読み込みしてください。',
  CATEGORY_NOT_FOUND: 'カテゴリが見つかりませんでした。',
  CATEGORY_RELOAD_DATA:
    'データに変更がありました。このページを再読み込みしてください。',
  CATEGORY_IN_USE: 'カテゴリは使用中のため削除できません。',
  ARTICLE_NOT_FOUND: '記事が見つかりませんでした。',
  ARTICLE_RELOAD_DATA:
    'データに変更がありました。このページを再読み込みしてください。',
  INPUT_HALF_SIZE: '半角文字で入力してください。',
  RESET_PASSWORD_INVALID:
    'リンクの有効期限が切れているか、すでに使用されています。再度お試しください。',
  COMPANY_NOT_FOUND: '団体情報が見つかりませんでした。',
  ARTICLE_ASSIGNED_TO_OTHER_COMPANY: 'データに変更がありました。このページを再読み込みしてください。',
};

export const ERROR_MESSAGE_FIELD = {
  UPLOAD_MISSING_FILE: (fieldName: string) =>
    `${fieldName}をアップロードしてください。`,
  DELETE_UNSUCCESS: (fieldName: string) =>
    `${fieldName}は使用中のため削除できません。`,
  NUMBERICAL_ORDER: (fieldName: string, min = 1) =>
    `${fieldName}は${min}以上である必要があります。`,
};

export const SUCCESS = {
  CREATE_NOTIFICATION: 'CREATE_NOTIFICATION',
  UPDATE_NOTIFICATION: 'UPDATE_NOTIFICATION',
  DELETE_NOTIFICATION: 'DELETE_NOTIFICATION',
  CREATE_SPECIALDAY: 'CREATE_SPECIALDAY',
  UPDATE_SPECIALDAY: 'UPDATE_SPECIALDAY',
  DELETE_SPECIALDAY: 'DELETE_SPECIALDAY',
  CREATE_EVENT: 'CREATE_EVENT',
  UPDATE_EVENT: 'UPDATE_EVENT',
  DELETE_EVENT: 'DELETE_EVENT',
  CREATE_BANNER: 'CREATE_BANNER',
  UPDATE_BANNER: 'UPDATE_BANNER',
  DELETE_BANNER: 'DELETE_BANNER',
  CREATE_CHAT_FUKUMARU: 'CREATE_CHAT_FUKUMARU',
  UPDATE_CHAT_FUKUMARU: 'UPDATE_CHAT_FUKUMARU',
  DELETE_CHAT_FUKUMARU: 'DELETE_CHAT_FUKUMARU',
  DELETE_COMMENT: 'DELETE_COMMENT',
  CREATE_PROMPT: 'CREATE_PROMPT',
  UPDATE_PROMPT: 'UPDATE_PROMPT',
  DELETE_PROMPT: 'DELETE_PROMPT',
  UPDATE_FUKUMARU: 'UPDATE_FUKUMARU',
  DELETE_FUKUMARU: 'DELETE_FUKUMARU',
  CREATE_CONTENT: 'CREATE_CONTENT',
  UPDATE_CONTENT: 'UPDATE_CONTENT',
  DELETE_CONTENT: 'DELETE_CONTENT',
  CREATE_SURVEY: 'CREATE_SURVEY',
  UPDATE_SURVEY: 'UPDATE_SURVEY',
  DELETE_SURVEY: 'DELETE_SURVEY',
  CREATE_NOTIFICATION_REMIND: 'CREATE_NOTIFICATION_REMIND',
  UPDATE_NOTIFICATION_REMIND: 'UPDATE_NOTIFICATION_REMIND',
  DELETE_NOTIFICATION_REMIND: 'DELETE_NOTIFICATION_REMIND',
  CREATE_SURVEY_HEALTH: 'CREATE_SURVEY_HEALTH',
  UPDATE_SURVEY_HEALTH: 'UPDATE_SURVEY_HEALTH',
  DELETE_SURVEY_HEALTH: 'DELETE_SURVEY_HEALTH',
  CREATE_SURVEY_HEALTH_QUESTION: 'CREATE_SURVEY_HEALTH_QUESTION',
  UPDATE_SURVEY_HEALTH_QUESTION: 'UPDATE_SURVEY_HEALTH_QUESTION',
  DELETE_SURVEY_HEALTH_QUESTION: 'DELETE_SURVEY_HEALTH_QUESTION',
  CREATE_APP_VERSION: 'CREATE_APP_VERSION',
  UPDATE_APP_VERSION: 'UPDATE_APP_VERSION',
  DELETE_APP_VERSION: 'DELETE_APP_VERSION',
  CREATE_CALENDAR_POST: 'CREATE_CALENDAR_POST',
  UPDATE_CALENDAR_POST: 'UPDATE_CALENDAR_POST',
  DELETE_CALENDAR_POST: 'DELETE_CALENDAR_POST',
  CREATE_PARTNER: 'CREATE_PARTNER',
  UPDATE_PARTNER: 'UPDATE_PARTNER',
  DELETE_PARTNER: 'DELETE_PARTNER',
  CREATE_OFFER: 'CREATE_OFFER',
  UPDATE_OFFER: 'UPDATE_OFFER',
  DELETE_OFFER: 'DELETE_OFFER',
  CREATE_CATEGORY: 'CREATE_CATEGORY',
  UPDATE_CATEGORY: 'UPDATE_CATEGORY',
  DELETE_CATEGORY: 'DELETE_CATEGORY',
  CREATE_ARTICLE: 'CREATE_ARTICLE',
  UPDATE_ARTICLE: 'UPDATE_ARTICLE',
  DELETE_ARTICLE: 'DELETE_ARTICLE',
  CREATE_GAME_INTRODUCTION: 'CREATE_GAME_INTRODUCTION',
  UPDATE_GAME_INTRODUCTION: 'UPDATE_GAME_INTRODUCTION',
  DELETE_GAME_INTRODUCTION: 'DELETE_GAME_INTRODUCTION',
  RESET_PW: 'RESET_PW',
  CREATE_COMPANY: 'CREATE_COMPANY',
  UPDATE_COMPANY: 'UPDATE_COMPANY',
};

export const SUCCESS_MESSAGE = {
  CREATE_NOTIFICATION: 'お知らせが正常に作成されました。',
  UPDATE_NOTIFICATION: 'お知らせが正常に更新されました。',
  DELETE_NOTIFICATION: 'お知らせが正常に削除されました。',
  CREATE_SPECIALDAY: 'CREATE_SPECIALDAY',
  UPDATE_SPECIALDAY: 'UPDATE_SPECIALDAY',
  DELETE_SPECIALDAY: 'DELETE_SPECIALDAY',
  CREATE_EVENT: 'イベントが正常に新規作成されました。',
  UPDATE_EVENT: 'イベントが正常に更新されました。',
  DELETE_EVENT: 'イベントが正常に削除されました。',
  CREATE_BANNER: 'バナーが正常に新規作成されました。',
  UPDATE_BANNER: 'バナーが正常に更新されました。',
  DELETE_BANNER: 'バナーが正常に削除されました。',
  CREATE_CHAT_FUKUMARU: 'トーク - フクマルが正常に新規作成されました。',
  UPDATE_CHAT_FUKUMARU: 'トーク - フクマルが正常に更新されました。',
  DELETE_CHAT_FUKUMARU: 'トーク - フクマルが正常に削除されました。',
  DELETE_COMMENT: 'コメントを削除しました。',
  CREATE_PROMPT: 'プロンプトが正常に新規作成されました。',
  UPDATE_PROMPT: 'プロンプトが正常に更新されました。',
  DELETE_PROMPT: 'プロンプトが正常に削除されました。',
  UPDATE_FUKUMARU: 'ふくまるが正常に更新されました。',
  DELETE_FUKUMARU: 'ふくまるが正常に削除されました。',
  CREATE_CONTENT: 'コンテンツが正常に作成されました。',
  UPDATE_CONTENT: 'コンテンツが正常に更新されました。',
  DELETE_CONTENT: 'コンテンツが正常に削除されました。',
  CREATE_SURVEY: 'アンケートが正常に作成されました。',
  UPDATE_SURVEY: 'アンケートが正常に更新されました。',
  DELETE_SURVEY: 'アンケートが正常に削除されました。',
  CREATE_NOTIFICATION_REMIND: 'お知らせが正常に作成されました。',
  UPDATE_NOTIFICATION_REMIND: 'お知らせが正常に更新されました。',
  DELETE_NOTIFICATION_REMIND: 'お知らせが正常に削除されました。',
  CREATE_SURVEY_HEALTH: 'アンケートが正常に作成されました。',
  UPDATE_SURVEY_HEALTH: 'アンケートが正常に更新されました。',
  DELETE_SURVEY_HEALTH: 'アンケートが正常に削除されました。',
  CREATE_SURVEY_HEALTH_QUESTION: '質問が正常に作成されました。',
  UPDATE_SURVEY_HEALTH_QUESTION: '質問が正常に更新されました。',
  DELETE_SURVEY_HEALTH_QUESTION: '質問が正常に削除されました。',
  CREATE_APP_VERSION: 'アプリバージョン正常に作成されました。',
  UPDATE_APP_VERSION: 'アプリバージョン正常に更新されました。',
  DELETE_APP_VERSION: 'アプリバージョン正常に削除されました。',
  CREATE_CALENDAR_POST: 'カレンダー投稿が正常に作成されました。',
  UPDATE_CALENDAR_POST: 'カレンダー投稿が正常に更新されました。',
  DELETE_CALENDAR_POST: 'カレンダー投稿が正常に削除されました。',
  CREATE_PARTNER: '企業プロフィール作成されました。',
  UPDATE_PARTNER: '企業プロフィール更新されました。',
  DELETE_PARTNER: '企業プロフィール削除されました。',
  CREATE_OFFER: 'オファーが正常に作成されました。',
  UPDATE_OFFER: 'オファーが正常に更新されました。',
  DELETE_OFFER: 'オファーが正常に削除されました。',
  CREATE_CATEGORY: 'カテゴリが正常に作成されました。',
  UPDATE_CATEGORY: 'カテゴリが正常に更新されました。',
  DELETE_CATEGORY: 'カテゴリが正常に削除されました。',
  CREATE_ARTICLE: '記事が正常に作成されました。',
  UPDATE_ARTICLE: '記事が正常に更新されました。',
  DELETE_ARTICLE: '記事が正常に削除されました。',
  CREATE_GAME_INTRODUCTION: 'ゲーム紹介が正常に作成されました。',
  UPDATE_GAME_INTRODUCTION: 'ゲーム紹介が正常に更新されました。',
  DELETE_GAME_INTRODUCTION: 'ゲーム紹介が正常に削除されました。',
  RESET_PW: 'パスワード再設定メールを送信しました。ご確認ください。',
  CREATE_COMPANY: '団体情報が正常に作成されました。',
  UPDATE_COMPANY: '団体情報が正常に更新されました。',
};
